import React from 'react';
import { organsAPI } from 'src/api/modules/organs';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import UtilInputs from 'src/common/components/UtilInputs';
import { editBodyForm } from '../utils/form_data';

const EditOrganModal = ({
	open,
	color = 'secondary',
	onClose,
	onSuccess,
	organ,
	onChangeData,
}) => {
	const onSaveData = () => {
		const organFlag = { ...organ };
		delete organFlag.organos;
		organsAPI
			.put(organ.id, { ...organFlag })
			.then((res) => {
				onSuccess('Se edito correctamente el órgano colegiado', 'success', 2);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Editar Órgano Colegiado"
			onConfirm={onSaveData}
			onClose={onClose}
			onCancel={onClose}
			color={color}
		>
			<UtilInputs
				width="95%"
				formValues={organ}
				inputValues={editBodyForm}
				onValuesChange={onChangeData}
			/>
		</BaseModal>
	);
};

export default EditOrganModal;
